export default {
	defaultConfig: {
		font: 'helvetica',
		margin: { left: 10, right: 10, top: 30 },
		cellWidth: 'auto',
		startX: 1,
		styles: {
			font: 'arial',
			fontSize: 10,
			cellPadding: 1,
			lineColor: [0, 0, 0],
			lineWidth: 0.1,
			valign: 'middle',
			rowPageBreak: 'always',
		},
		columnStyles: { text: { cellWidth: 'auto' } },
		headStyles:{
			valign: 'middle',
			halign : 'center'
		}
	}
}
  
